module.exports = __webpack_public_path__ + "static/media/registerGraham.d520d8d7.png";